function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9997 4.26519L12.8379 1.61872L14.783 4.41914L15.125 4.91161L15.4671 4.41914L17.1026 2.06437V11.9789H8.75106V2.0127L10.3156 4.2652L10.6577 4.75765L10.9997 4.26519Z",
  fill: "#FFD9B0",
  stroke: "#055445",
  strokeWidth: 0.832926
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2129 11.5624H4.64064C2.07769 11.5624 0 13.6401 0 16.203V37.2141C0 39.777 2.07769 41.8547 4.64064 41.8547H21.2129C23.7759 41.8547 25.8536 39.777 25.8536 37.2141V16.203C25.8536 13.6401 23.7759 11.5624 21.2129 11.5624Z",
  fill: "#055445"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7352 16.5211H7.01906C6.43865 16.5211 5.96814 16.9916 5.96814 17.572V23.5743C5.96814 24.1547 6.43865 24.6252 7.01906 24.6252H19.7352C20.3156 24.6252 20.7861 24.1547 20.7861 23.5743V17.572C20.7861 16.9916 20.3156 16.5211 19.7352 16.5211Z",
  fill: "white",
  stroke: "#055445",
  strokeWidth: 1.01405,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.77197 28.6122H9.65371",
  stroke: "#FFD9B0",
  strokeWidth: 1.32287,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.917 28.6122H14.7987",
  stroke: "#FFD9B0",
  strokeWidth: 1.32287,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1014 28.6122H19.9823",
  stroke: "#FFD9B0",
  strokeWidth: 1.32287,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.77197 31.3907H9.65371",
  stroke: "#FFD9B0",
  strokeWidth: 1.32287,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M11.917 31.3907H14.7987",
  stroke: "#FFD9B0",
  strokeWidth: 1.32287,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1014 31.3907H19.9823",
  stroke: "#FFD9B0",
  strokeWidth: 1.32287,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M6.77197 34.1693H9.65371",
  stroke: "#FFD9B0",
  strokeWidth: 1.32287,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M11.917 34.1693H19.9823",
  stroke: "#FFD9B0",
  strokeWidth: 1.32287,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8516 20.4998L13.2998 21.6144L15.7953 19.1189",
  stroke: "#055445",
  strokeWidth: 1.01405,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7211 23.6388H30.2618C31.2532 23.639 32.2038 24.033 32.9048 24.7339C33.6058 25.4349 33.9997 26.3856 34 27.3769V45.7091C33.9995 46.7002 33.6054 47.6507 32.9045 48.3515C32.2035 49.0522 31.253 49.446 30.2618 49.4463H18.7211C18.2301 49.4463 17.7439 49.3496 17.2903 49.1616C16.8367 48.9737 16.4246 48.6983 16.0775 48.3511C15.7303 48.0039 15.455 47.5917 15.2672 47.138C15.0794 46.6844 14.9828 46.1982 14.9829 45.7072V27.3769C14.9829 26.3855 15.3767 25.4347 16.0778 24.7337C16.7788 24.0326 17.7296 23.6388 18.7211 23.6388Z",
  fill: "#E4FFE1",
  stroke: "#055445",
  strokeWidth: 1.66211,
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5493 23.6388H25.2737V49.4481H29.5493V23.6388Z",
  fill: "#2AAAF9",
  stroke: "#055445",
  strokeWidth: 1.47774,
  strokeMiterlimit: 10
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6882 46.0215C20.7065 46.0215 21.5319 45.1961 21.5319 44.1778C21.5319 43.1596 20.7065 42.3341 19.6882 42.3341C18.6699 42.3341 17.8445 43.1596 17.8445 44.1778C17.8445 45.1961 18.6699 46.0215 19.6882 46.0215Z",
  fill: "#E5B620"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.67,
  d: "M19.6882 43.9658C20.7065 43.9658 21.5319 43.1403 21.5319 42.122C21.5319 41.1038 20.7065 40.2783 19.6882 40.2783C18.6699 40.2783 17.8445 41.1038 17.8445 42.122C17.8445 43.1403 18.6699 43.9658 19.6882 43.9658Z",
  fill: "#EF3C2E"
});

function SvgWithdrawMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 51,
    viewBox: "0 0 35 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawMoney);
export default __webpack_public_path__ + "static/media/withdrawMoney.321586e8cb932d97a8b514f7b0a21bf1.svg";
export { ForwardRef as ReactComponent };